"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryResultSerializeStats = void 0;
const bus_query_result_serialize_1 = require("@comunica/bus-query-result-serialize");
const readable_stream_1 = require("readable-stream");
/**
 * Serializes SPARQL results for testing and debugging.
 */
class ActorQueryResultSerializeStats extends bus_query_result_serialize_1.ActorQueryResultSerializeFixedMediaTypes {
    /* eslint-disable max-len */
    /**
     * @param args -
     *   \ @defaultNested {{ "stats": 0.5 }} mediaTypePriorities
     *   \ @defaultNested {{ "stats": "https://comunica.linkeddatafragments.org/#results_stats" }} mediaTypeFormats
     *   \ @defaultNested {<default_observer> a <caqrsst:components/ActionObserverHttp.jsonld#ActionObserverHttp>} httpObserver
     */
    constructor(args) {
        super(args);
    }
    /* eslint-enable max-len */
    async testHandleChecked(action, context) {
        if (!['bindings', 'quads'].includes(action.type)) {
            throw new Error('This actor can only handle bindings streams or quad streams.');
        }
        return true;
    }
    pushHeader(data) {
        const header = ['Result', 'Delay (ms)', 'HTTP requests',
        ].join(',');
        data.push(`${header}\n`);
    }
    pushStat(data, startTime, result) {
        const row = [result, this.delay(startTime), this.httpObserver.requests,
        ].join(',');
        data.push(`${row}\n`);
    }
    pushFooter(data, startTime) {
        const footer = ['TOTAL', this.delay(startTime), this.httpObserver.requests,
        ].join(',');
        data.push(`${footer}\n`);
        data.push(null);
    }
    async runHandle(action, mediaType, context) {
        const data = new readable_stream_1.Readable();
        data._read = () => {
            // Do nothing
        };
        const resultStream = action.type === 'bindings' ?
            action.bindingsStream :
            action.quadStream;
        const startTime = this.now();
        let result = 1;
        this.pushHeader(data);
        resultStream.on('error', error => data.emit('error', error));
        resultStream.on('data', () => this.pushStat(data, startTime, result++));
        resultStream.on('end', () => this.pushFooter(data, startTime));
        return { data };
    }
    /* istanbul ignore next */
    now() {
        // TODO: remove when we will drop support of Node 14
        if (typeof performance === 'undefined') {
            const time = process.hrtime();
            return time[0] * 1000 + (time[1] / 1000000);
        }
        return performance.now();
    }
    delay(startTime) {
        return this.now() - startTime;
    }
}
exports.ActorQueryResultSerializeStats = ActorQueryResultSerializeStats;
//# sourceMappingURL=ActorQueryResultSerializeStats.js.map